import template from './total-area.jade';
import validation from '../../../../services/validation';

export default angular
  .module('cian.addForm.helperBuildingTotalArea', [])
  .directive('cianAfHelperBuildingTotalArea', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
      required: '=',
    },
    controller: [
      '$timeout',
      'deviceService',
      'store',
      'config',
      function ($timeout, deviceService) {
        this.isMobile = deviceService.isMobile;
        this.areaMax = 10000000;
        this.areaMin = 0;

        $timeout(() => {
          this.validation = validation(this.form, 'building.totalArea', {
            parse: 'Введите число',
            required: 'Укажите площадь',
            min: 'Площадь должна быть больше 0',
            max: 'Допустимо не более 7 символов',
          });
        }, 0);
      },
    ],
    controllerAs: 'totalArea',
    template,
  })).name;
